import { Component } from '@angular/core';

@Component({
  selector: 'app-horizontal-box-list',
  templateUrl: './horizontal-box-list.component.html',
  styleUrl: './horizontal-box-list.component.scss'
})
export class HorizontalBoxListComponent {

}
